<template>
  <RevBreadcrumbs
    :ariaLabel="i18n(translations.breadcrumbAriaLabel)"
    :breads
    class="px-16 md:px-32"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevBreadcrumbs } from '@ds/components/Breadcrumbs'

import { CMS } from '~/scopes/cms/routes-names'

import translations from './BuybackBreadcrumb.translations'

const props = defineProps<{
  productName: string
}>()

const i18n = useI18n()

const breads = computed(() => [
  {
    title: i18n(translations.breadcrumbHome),
    link: { name: CMS.BUYBACK, params: { pageName: 'home' } },
  },
  {
    title: props.productName,
    link: {},
  },
])
</script>
